import { AdminModeState } from '../features/adminMode/definitions'
import { ChatStore } from '../features/chat/definitions'
import { EditorState } from '../features/editor/definitions'
import { RealmState } from '../features/realm/realmSlice'
import { VisualizationState } from '../features/visualizationMode/visualizationModeSlice'

export const loadAdminModeLocalStorage = (): AdminModeState | undefined => {
  try {
    const serialisedState = localStorage.getItem('hcAdminModeState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState) as AdminModeState
  } catch (e) {
    return undefined
  }
}

export const loadRealmLocalStorage = (): RealmState | undefined => {
  try {
    const serialisedState = localStorage.getItem('hcRealmState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState) as RealmState
  } catch (e) {
    return undefined
  }
}

export const loadVisualizationLocalStorage = (): VisualizationState | undefined => {
  try {
    const serialisedState = localStorage.getItem('hcVisualizationState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState) as VisualizationState
  } catch (e) {
    return undefined
  }
}

export const loadEditorLocalStorage = (): EditorState | undefined => {
  try {
    const serialisedState = localStorage.getItem('hcEditorState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState) as EditorState
  } catch (e) {
    return undefined
  }
}

export const loadChatLocalStorage = (): ChatStore | undefined => {
  try {
    const serialisedState = localStorage.getItem('hcChatState')
    if (serialisedState === null) return undefined
    return JSON.parse(serialisedState) as ChatStore
  } catch (e) {
    return undefined
  }
}

export const saveStateToLocalStorage = (adminMode: AdminModeState, realm: RealmState, visualization: VisualizationState, editor: EditorState, chat: ChatStore): void => {
  localStorage.setItem('hcAdminModeState', JSON.stringify(adminMode))
  localStorage.setItem('hcRealmState', JSON.stringify(realm))
  localStorage.setItem('hcVisualizationState', JSON.stringify(visualization))
  localStorage.setItem('hcEditorState', JSON.stringify(editor))
  localStorage.setItem('hcChatState', JSON.stringify(chat))
}
